import { useEffect, useState } from "react";

// Delayed value: Current value that needs input watches
// Display value: Value that displays on the input for the user visual feedback
// 
export const useDelayedState: (
  initialValue: any,
  timeoutDelay: number
) => [any, any, React.Dispatch<any>] = (initialValue, timeoutDelay) => {
  const [delayedValue, setDelayedValue] = useState<any>(initialValue);
  const [displayValue, setDisplayValue] = useState<any>(initialValue);

  useEffect(() => {
    const timeOutId = setTimeout(
      () => setDelayedValue(displayValue),
      timeoutDelay
    );
    return () => clearTimeout(timeOutId);
  }, [displayValue]);

  return [delayedValue, displayValue, setDisplayValue];
};
